import React, { useEffect, useState } from 'react';
import { DayData } from '../utils/mockData';
interface DayCellProps {
  day: DayData;
  delay: number;
}
interface MiniBarProps {
  value: number;
  max: number;
  color: string;
  delay: number;
}
function MiniBar({
  value,
  max,
  color,
  delay
}: MiniBarProps) {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setHeight(value / max * 100);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, max, delay]);
  return <div className="flex-1 flex flex-col items-center justify-end h-16" data-id="element-35">
      <div className="w-full bg-gray-700 rounded-t relative overflow-hidden" style={{
      height: '100%'
    }} data-id="element-36">
        <div className={`absolute bottom-0 w-full rounded-t transition-all duration-500 ease-out ${color}`} style={{
        height: `${height}%`
      }} data-id="element-37" />
      </div>
    </div>;
}
export function DayCell({
  day,
  delay
}: DayCellProps) {
  const maxMacro = Math.max(day.protein, day.carbs, day.fats);
  const isDeficit = day.caloriesIn < day.caloriesOut;
  return <div className="bg-gray-800 rounded-lg p-4 border border-gray-700 transition-all hover:border-gray-600 hover:shadow-lg" style={{
    animation: `fadeIn 0.5s ease-out ${delay}ms both`
  }} data-id="element-38">
      <div className="flex items-center justify-between mb-3" data-id="element-39">
        <span className="text-gray-400 text-sm font-medium" data-id="element-40">{day.dayName}</span>
        <span className={`text-xs font-bold ${isDeficit ? 'text-green-500' : 'text-orange-500'}`} data-id="element-41">
          {isDeficit ? '-' : '+'}
          {Math.abs(day.caloriesIn - day.caloriesOut)}
        </span>
      </div>

      <div className="flex gap-2 mb-3" data-id="element-42">
        <MiniBar value={day.protein} max={maxMacro} color="bg-green-500" delay={delay + 200} data-id="element-43" />
        <MiniBar value={day.carbs} max={maxMacro} color="bg-blue-500" delay={delay + 300} data-id="element-44" />
        <MiniBar value={day.fats} max={maxMacro} color="bg-orange-500" delay={delay + 400} data-id="element-45" />
      </div>

      <div className="flex justify-between text-xs text-gray-500" data-id="element-46">
        <span data-id="element-47">P: {day.protein}g</span>
        <span data-id="element-48">C: {day.carbs}g</span>
        <span data-id="element-49">F: {day.fats}g</span>
      </div>
    </div>;
}